import { Injectable } from '@angular/core';

import { LazyClientConfig } from '../lazy/lazy-client-config.decorator';
import { LazyClientConfigBase, LazyClientConfigService } from '../lazy/lazy-client-config.service';
import { ClientConfigProductName } from './client-config-product-name.model';

@LazyClientConfig({ key: 'vnPlatformProductMap', product: ClientConfigProductName.SF })
@Injectable()
export class PlatformProductMapConfig extends LazyClientConfigBase {
    platformProductMap: { [key: string]: string };
}

export function configFactory(service: LazyClientConfigService): PlatformProductMapConfig {
    return service.get(PlatformProductMapConfig);
}
